import {
    UPDATELOADCOUNT_SUCCESS,
    UPDATELOADCOUNT_FAILED,
    RESET_UPDATELOADCOUNT,
    LOADING_UPDATELOADCOUNT,
    NETWORK_ERROR_UPDATELOADCOUNT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateLoadCount = () => {
    return { type: RESET_UPDATELOADCOUNT };
};

const updateLoadCount = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATELOADCOUNT });
    await partnerServices
        .post("updateNumberOfLoad", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(updateLoadCountsuccess(res.data));
                    break;
                default:
                    dispatch(updateLoadCountFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_UPDATELOADCOUNT, payload: err });
        });
};
function updateLoadCountsuccess(data) {
    return {
        type: UPDATELOADCOUNT_SUCCESS,
        payload: data,
    };
}
function updateLoadCountFailed(data) {
    return {
        type: UPDATELOADCOUNT_FAILED,
        payload: data,
    };
}

export { resetUpdateLoadCount, updateLoadCount };